import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../i18n/LanguageContext'
import MetaTags from '../components/MetaTags'
import ScrollReveal from '../components/ScrollReveal'

export default function AboutPage() {
  const { t, getPageUrl } = useLanguage()

  return (
    <div className="bg-slate-50 min-h-screen pb-20">
      <MetaTags
        title={t.about.metaTitle}
        description={t.about.metaDesc}
      />

      {/* Header Banner */}
      <section className="bg-gradient-to-br from-slate-100 via-sky-50/60 to-white text-slate-900 py-12 lg:py-16 border-b border-slate-200 relative overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mb-4">
              {t.about.headerTitle}
            </h1>
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              {t.about.headerSubtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          <ScrollReveal variant="left" className="space-y-6">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900 border-b border-slate-200 pb-4">
              {t.about.mainHeading}
            </h2>

            <p className="text-slate-700 leading-relaxed text-base">
              {t.about.p1}
            </p>

            <p className="text-slate-700 leading-relaxed text-base">
              {t.about.p2}
            </p>

            <div className="space-y-4 pt-2">
              <h3 className="text-lg font-bold text-slate-900">
                {t.about.reliabilityHeading}
              </h3>
              <p className="text-slate-700 leading-relaxed text-base">
                {t.about.p3}
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                {t.about.p4}
              </p>
            </div>

            <div className="pt-4 border-t border-slate-200 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-4 bg-white rounded-none border border-slate-200 shadow-sm">
                <span className="text-xs font-bold uppercase tracking-wider text-sky-600 block mb-1">{t.about.locationBadge}</span>
                <span className="font-bold text-slate-900 block text-sm">{t.about.locationAddress}</span>
                <span className="text-slate-500 text-xs">{t.about.locationStreet}</span>
              </div>

              <div className="p-4 bg-white rounded-none border border-slate-200 shadow-sm">
                <span className="text-xs font-bold uppercase tracking-wider text-sky-600 block mb-1">{t.about.cvrBadge}</span>
                <span className="font-bold text-slate-900 block text-sm">{t.about.cvrValue}</span>
                <span className="text-slate-500 text-xs">{t.about.cvrSubtitle}</span>
              </div>
            </div>
          </ScrollReveal>

          {/* Visual Showcase */}
          <ScrollReveal variant="right" className="space-y-6">
            <div className="rounded-none overflow-hidden shadow-lg border border-slate-200">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/ed865070-334e-4849-904d-48dc93d1adc7/734101346-1054615956904113-4096849147404615392-n.jpg" 
                alt="M.Rou Transport lastbil på vej" 
                className="w-full h-auto object-cover"
              />
            </div>

            <div className="bg-white text-slate-900 p-8 rounded-none shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold text-slate-900 mb-3">{t.about.focusHeading}</h3>
              <ul className="space-y-2.5 text-sm text-slate-700">
                {t.about.focusPoints.map((point, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-sky-600"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 pt-6 border-t border-slate-200 flex flex-wrap gap-4">
                <Link
                  to={getPageUrl('contact')}
                  className="bg-sky-600 hover:bg-sky-500 text-white font-bold py-2.5 px-5 rounded-none text-sm hover:-translate-y-1 active:translate-y-0 transition-all shadow-sm hover:shadow-md"
                >
                  {t.about.contactToday}
                </Link>
                <a
                  href="tel:+4525303016"
                  className="bg-slate-100 hover:bg-slate-200 text-slate-900 border border-slate-300 font-bold py-2.5 px-5 rounded-none text-sm hover:-translate-y-1 active:translate-y-0 transition-all shadow-sm hover:shadow-md whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">+45 25 30 30 16</span>
                </a>
              </div>
            </div>
          </ScrollReveal>

        </div>
      </section>
    </div>
  )
}
